__turbopack_context__.v({
  "dropdown": "EffektDropdown-module-scss-module__9fJSJa__dropdown",
  "dropdown__input": "EffektDropdown-module-scss-module__9fJSJa__dropdown__input",
  "dropdown__input__icon": "EffektDropdown-module-scss-module__9fJSJa__dropdown__input__icon",
  "dropdown__input__text": "EffektDropdown-module-scss-module__9fJSJa__dropdown__input__text",
  "dropdown__options": "EffektDropdown-module-scss-module__9fJSJa__dropdown__options",
  "dropdown__options__list": "EffektDropdown-module-scss-module__9fJSJa__dropdown__options__list",
  "dropdown__options__list__option": "EffektDropdown-module-scss-module__9fJSJa__dropdown__options__list__option",
  "dropdown__options__search": "EffektDropdown-module-scss-module__9fJSJa__dropdown__options__search",
  "wrapper": "EffektDropdown-module-scss-module__9fJSJa__wrapper",
});
